/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeleteGlobalOptOutRequest,
  ErrorModel,
  ListGlobalOptOutsOutputBody,
  MessageOutputBody,
} from '../models/index';
import {
    DeleteGlobalOptOutRequestFromJSON,
    DeleteGlobalOptOutRequestToJSON,
    ErrorModelFromJSON,
    ErrorModelToJSON,
    ListGlobalOptOutsOutputBodyFromJSON,
    ListGlobalOptOutsOutputBodyToJSON,
    MessageOutputBodyFromJSON,
    MessageOutputBodyToJSON,
} from '../models/index';

export interface CreateGlobalOptOutRequest {
    email?: string;
}

export interface DeleteGlobalOptOutOperationRequest {
    deleteGlobalOptOutRequest: Omit<DeleteGlobalOptOutRequest, '$schema'>;
}

export interface ListGlobalOptOutsRequest {
    email?: string;
}

/**
 * 
 */
export class GlobalOptOutsApi extends runtime.BaseAPI {

    /**
     * Creates request options for createGlobalOptOut without sending the request
     */
    async createGlobalOptOutRequestOpts(requestParameters: CreateGlobalOptOutRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/global-opt-out`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Create global opt out for the submitted email address
     * Create Global Opt Out
     */
    async createGlobalOptOutRaw(requestParameters: CreateGlobalOptOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageOutputBody>> {
        const requestOptions = await this.createGlobalOptOutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageOutputBodyFromJSON(jsonValue));
    }

    /**
     * Create global opt out for the submitted email address
     * Create Global Opt Out
     */
    async createGlobalOptOut(requestParameters: CreateGlobalOptOutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageOutputBody> {
        const response = await this.createGlobalOptOutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteGlobalOptOut without sending the request
     */
    async deleteGlobalOptOutRequestOpts(requestParameters: DeleteGlobalOptOutOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deleteGlobalOptOutRequest'] == null) {
            throw new runtime.RequiredError(
                'deleteGlobalOptOutRequest',
                'Required parameter "deleteGlobalOptOutRequest" was null or undefined when calling deleteGlobalOptOut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/global-opt-out`;

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteGlobalOptOutRequestToJSON(requestParameters['deleteGlobalOptOutRequest']),
        };
    }

    /**
     * Delete global opt out for the current user
     * Delete Global Opt Out
     */
    async deleteGlobalOptOutRaw(requestParameters: DeleteGlobalOptOutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageOutputBody>> {
        const requestOptions = await this.deleteGlobalOptOutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageOutputBodyFromJSON(jsonValue));
    }

    /**
     * Delete global opt out for the current user
     * Delete Global Opt Out
     */
    async deleteGlobalOptOut(requestParameters: DeleteGlobalOptOutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageOutputBody> {
        const response = await this.deleteGlobalOptOutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listGlobalOptOuts without sending the request
     */
    async listGlobalOptOutsRequestOpts(requestParameters: ListGlobalOptOutsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/global-opt-out`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List global opt outs for the authenticated user
     * List Global Opt Outs
     */
    async listGlobalOptOutsRaw(requestParameters: ListGlobalOptOutsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListGlobalOptOutsOutputBody>> {
        const requestOptions = await this.listGlobalOptOutsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListGlobalOptOutsOutputBodyFromJSON(jsonValue));
    }

    /**
     * List global opt outs for the authenticated user
     * List Global Opt Outs
     */
    async listGlobalOptOuts(requestParameters: ListGlobalOptOutsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListGlobalOptOutsOutputBody> {
        const response = await this.listGlobalOptOutsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
